export default {
  grayHeader: "宿泊ギフト券の使い方",
  web: {
    header: "ネットの場合",
    description: "星野リゾート宿泊ギフト券は必ず宿にご持参ください",
    step1: [
      {label: "宿の予約サイトへ<br />アクセス"}
    ],
    step2: [
      {label: "予約時に専用フォームへ<br />券面記載のギフト券番号を入力"},
      {tip: "※ 下記「入力例」を参照"}
    ],
    step3: [
      {label: "宿泊当日にスタッフへ<br />ギフト券を提出"}
    ],
    example: "入力例："
  },
  phone: {
    header: "電話の場合",
    step1: [
      {label: "星野リゾート<br />予約センターへ電話"}
    ],
    step2: [
      {label: "券面記載の<br />ギフト券番号を伝える"}
    ],
    step3: [
      {label: "宿泊当日にスタッフへ<br />ギフト券を提出"}
    ]
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/about/gift/index.js